export default __webpack_public_path__ + "7f8676ebefd74bebd9a1889d77078288.svg";